import { action, observable } from 'mobx';
import { BaseGlobalEntityStore } from './base-global-entity.store';
import { User } from '~/models/user.model';
import { IMember, IUserResponse } from '~/types/server.types';
import { RolloutFeatureFlags } from '~/services/feature.service';
import { TGlobalContext, PartialWithRequired } from '~/types/app.types';
import { isUserLessMode } from '~/utils/user-less-mode-flow.utils';
import { setCompanyAndAccountInStores } from '~/utils/user.utils';

export interface IUserGetter {
    get currUser(): User;
    get fingerprint(): string;

    byId(_id: string): User;
    update(item: PartialWithRequired<IUserResponse, '_id'>): void;
    setFingerprint(fingerprint: string): void;
}

export abstract class BaseUserStore
    extends BaseGlobalEntityStore<IUserResponse, User>
    implements IUserGetter
{
    @observable fingerprint: string;

    constructor(globalContext: TGlobalContext) {
        super(globalContext, User);
    }

    abstract get currUser(): User;

    // TODO: should be be saved on user? Maybe session stroe?
    @action.bound
    setFingerprint(fingerprint: string) {
        this.fingerprint = fingerprint;
    }

    isFeatureActive(feature: RolloutFeatureFlags, variation = 'on') {
        return this.currUser?.isFeatureActive(feature, variation);
    }

    isCurrentUser(client: Pick<IMember, '_id' | 'email'>) {
        //  no user should be considered current user in viewer mode
        if (isUserLessMode() || !client) {
            return false;
        }

        return (
            client._id === this.currUser._id ||
            client.email === this.currUser.email
        );
    }

    update(item: Partial<IUserResponse> & { _id: string }): User {
        const user = super.update(item);

        setCompanyAndAccountInStores({
            globalContext: this.globalContext,
            account: item.account,
            company: item.company
        });

        return user;
    }
}
